import React, { useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useServiceStore } from "../../../stores/admin/service";
import Users from "../../../assets/icons/users.svg";
import Folder from "../../../assets/icons/folder.svg";
import Categories from "../../../assets/icons/bookmark.svg";
import WhiteTriangle from "../../../assets/icons/whiteTriangle.svg";
import Layout from "../../../assets/icons/layout.svg";
import invoices from "../../../assets/icons/invoices.svg";

const NavBarAdmin = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { navBarSelected, setNavBarSelected } = useServiceStore();
  const { idPartner } = useParams();

  useEffect(() => {
    if (location.pathname.includes("/users/partner"))
      setNavBarSelected("users");
  }, []);

  useEffect(() => {
    if (navBarSelected === "users" && !location.pathname.includes("customer"))
      navigate(`/partner/${idPartner}/admin/users/partner`);
    if (navBarSelected === "folders" && !location.pathname.includes("mission"))
      navigate(`/partner/${idPartner}/admin/clientfile`);
    if (
      navBarSelected === "parameters" &&
      !location.pathname.includes("relaunch")
    )
      navigate(`/partner/${idPartner}/admin/category`);

    if (navBarSelected === "invoices" && !location.pathname.includes("invoice"))
      navigate(`/partner/${idPartner}/admin/invoice`);
  }, [navBarSelected]);

  return (
    <div className="w-16 md:w-44 lg:w-52 2xl:w-80 h-full shadow-xl flex flex-col justify-start items-center bg-dark-lavender z-50">
      <div className="w-full flex justify-center items-start mt-2">
        <ul className="w-[56px] bg-light-lavender h-screen flex flex-col items-center justify-start text-sm font-K2D">
          <li
            className={`w-full h-16 flex justify-center items-center cursor-pointer ${
              navBarSelected === "users" ? "bg-dark-lavender" : ""
            }`}
            onClick={() => setNavBarSelected("users")}
          >
            <img src={Users} alt="icon utilisateurs" />
          </li>
          <li
            className={`w-full h-16 flex justify-center items-center cursor-pointer ${
              navBarSelected === "folders" ? "bg-dark-lavender" : ""
            }`}
            onClick={() => setNavBarSelected("folders")}
          >
            <img src={Folder} alt="icon fichiers" />
          </li>
          <li
            className={`w-full h-16 flex justify-center items-center cursor-pointer ${
              navBarSelected === "parameters" ? "bg-dark-lavender" : ""
            }`}
            onClick={() => setNavBarSelected("parameters")}
          >
            <img src={Categories} alt="icon categories" />
          </li>
          <li
            className={`w-full h-16 flex justify-center items-center cursor-pointer ${
              navBarSelected === "layout" ? "bg-dark-lavender" : ""
            }`}
          >
            <Link to={`/partner/${idPartner}/customers`}>
              <img src={Layout} alt="icon Layout" />
            </Link>
          </li>
        </ul>
        <div className="w-[300px] h-screen flex flex-col items-start justify-start text-sm font-K2D p-4 space-y-3">
          {navBarSelected === "users" ? (
            <>
              <Link
                to={`/partner/${idPartner}/admin/users/partner`}
                className={`w-full px-4 py-3 rounded-lg border transition-all duration-200 ease-in-out flex items-center justify-between group ${
                  location.pathname === `/partner/${idPartner}/admin/users/partner`
                    ? "bg-blue-50 border-blue-200 text-dark-lavender shadow-md"
                    : "bg-white border-gray-200 text-gray-700 hover:bg-gray-50 hover:border-gray-300 hover:shadow-sm"
                }`}
              >
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4 text-grey-trio" fill="none" stroke="#9ba5c0" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                  <span className="font-medium">Partenaires</span>
                </div>
                {location.pathname === `/partner/${idPartner}/admin/users/partner` && (
                  <img
                  src={WhiteTriangle}
                  alt="flèche"
                  className="w-3 h-3 text-blue-600 rotate-90"
                  />
                )}
              </Link>
              <Link
                to={`/partner/${idPartner}/admin/users/customer`}
                className={`w-full px-4 py-3 rounded-lg border transition-all duration-200 ease-in-out flex items-center justify-between group ${
                  location.pathname === `/partner/${idPartner}/admin/users/customer`
                    ? "bg-blue-50 border-blue-200 text-dark-lavender shadow-md"
                    : "bg-white border-gray-200 text-gray-700 hover:bg-gray-50 hover:border-gray-300 hover:shadow-sm"
                }`}
              >
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4 text-black" fill="none" stroke="#9ba5c0" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                  <span className="font-medium">Clients</span>
                </div>
                {location.pathname === `/partner/${idPartner}/admin/users/customer` && (
                  <img
                    src={WhiteTriangle}
                    alt="flèche"
                    className="w-3 h-3 text-blue-600 rotate-90"
                  />
                )}
              </Link>
            </>
          ) : navBarSelected === "folders" ? (
            <>
              <Link
                to={`/partner/${idPartner}/admin/clientfile`}
                className={`w-full px-4 py-3 rounded-lg border transition-all duration-200 ease-in-out flex items-center justify-between group ${
                  location.pathname.includes("clientfile")
                    ? "bg-blue-50 border-blue-200 text-dark-lavender shadow-md"
                    : "bg-white border-gray-200 text-gray-700 hover:bg-gray-50 hover:border-gray-300 hover:shadow-sm"
                }`}
              >
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4 text-black" fill="none" stroke="#9ba5c0" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <span className="font-medium">Dossiers clients</span>
                </div>
                {location.pathname.includes("clientfile") && (
                  <img
                    src={WhiteTriangle}
                    alt="flèche"
                    className="w-3 h-3 text-blue-600 rotate-90"
                  />
                )}
              </Link>
              <Link
                to={`/partner/${idPartner}/admin/mission`}
                className={`w-full px-4 py-3 rounded-lg border transition-all duration-200 ease-in-out flex items-center justify-between group ${
                  location.pathname.includes("mission")
                    ? "bg-blue-50 border-blue-200 text-dark-lavender shadow-md"
                    : "bg-white border-gray-200 text-gray-700 hover:bg-gray-50 hover:border-gray-300 hover:shadow-sm"
                }`}
              >
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4 text-black" fill="none" stroke="#9ba5c0" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                  </svg>
                  <span className="font-medium">Missions</span>
                </div>
                {location.pathname.includes("mission") && (
                  <img
                    src={WhiteTriangle}
                    alt="flèche"
                    className="w-3 h-3 text-blue-600 rotate-90"
                  />
                )}
              </Link>
            </>
          ) : navBarSelected === "parameters" ? (
            <>
              <Link
                to={`/partner/${idPartner}/admin/category`}
                className={`w-full px-4 py-3 rounded-lg border transition-all duration-200 ease-in-out flex items-center justify-between group ${
                  location.pathname.includes("category")
                    ? "bg-blue-50 border-blue-200 text-dark-lavender shadow-md"
                    : "bg-white border-gray-200 text-gray-700 hover:bg-gray-50 hover:border-gray-300 hover:shadow-sm"
                }`}
              >
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4 text-grey-trio" fill="none" stroke="#9ba5c0" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                  </svg>
                  <span className="font-medium">Catégories</span>
                </div>
                {location.pathname.includes("category") && (
                  <img
                    src={WhiteTriangle}
                    alt="flèche"
                    className="w-3 h-3 text-blue-600 rotate-90"
                  />
                )}
              </Link>
              <Link
                to={`/partner/${idPartner}/admin/relaunch`}
                className={`w-full px-4 py-3 rounded-lg border transition-all duration-200 ease-in-out flex items-center justify-between group ${
                  location.pathname.includes("relaunch")
                    ? "bg-blue-50 border-blue-200 text-dark-lavender shadow-md"
                    : "bg-white border-gray-200 text-gray-700 hover:bg-gray-50 hover:border-gray-300 hover:shadow-sm"
                }`}
              >
                 <div className="flex items-center gap-2">
                 <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9ba5c0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-repeat"><polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path></svg>                  <span className="font-medium">Relances</span>
                </div>
                {location.pathname.includes("relaunch") && (
                  <img
                    src={WhiteTriangle}
                    alt="flèche"
                    className="w-3 h-3 text-blue-600 rotate-90"
                  />
                )}
              </Link>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default React.memo(NavBarAdmin);
